import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { auth } from 'firebase/index'
import dexieDb from 'lib/db'
import { signOutAction } from 'reducks/auth/actions'
import { push } from 'connected-react-router'
import { initRootState } from 'reducks/auth/operations'

const signOut = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(showLoadingAction())

    return auth
      .signOut()
      .then(async () => {
        await dexieDb.auth.put({
          uid: getState().auth.uid,
          is_admin: false,
          is_signed_in: false,
          role: 0,
          brand_id: undefined,
          shop_id: undefined,
          store_id: undefined,
        })
        // Storeの初期化
        dispatch(signOutAction())
        initRootState(dispatch)
        dispatch(hideLoadingAction())
        dispatch(push('/'))
      })
      .catch(() => {
        throw new Error('ログアウトに失敗しました。')
      })
  }
}

export default signOut
